import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center space-x-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/5d580fd3-a3b6-490e-b0ef-049ae78adcd3.png" 
              alt="Outsmart Digital Services" 
              className="h-12 w-auto"
            />
            <span className={`text-base lg:text-3xl font-bold transition-colors ${
              scrolled ? 'text-gray-900' : 'text-white'
            }`}>
              Outsmarwebs
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            <a onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-cyan-600' : 'text-white hover:text-cyan-200'
            }`}>
              Services
            </a>
            <a onClick={() => scrollToSection('portfolio')} className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-cyan-600' : 'text-white hover:text-cyan-200'
            }`}>
              Portfolio
            </a>
            <a onClick={() => scrollToSection('pricing')} className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-cyan-600' : 'text-white hover:text-cyan-200'
            }`}>
              Pricing
            </a>
            <a onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors cursor-pointer ${
              scrolled ? 'text-gray-700 hover:text-cyan-600' : 'text-white hover:text-cyan-200'
            }`}>
              About
            </a>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-sm font-semibold rounded-full hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer"
          >
            <div className="w-6 h-5 flex flex-col justify-between">
              <span className={`block h-0.5 w-full transition-all duration-300 ${
                scrolled ? 'bg-gray-900' : 'bg-white'
              } ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
              <span className={`block h-0.5 w-full transition-all duration-300 ${
                scrolled ? 'bg-gray-900' : 'bg-white'
              } ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 w-full transition-all duration-300 ${
                scrolled ? 'bg-gray-900' : 'bg-white'
              } ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200 py-4">
            <div className="flex flex-col gap-4 py-6">
              <a onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-cyan-600 transition-colors cursor-pointer px-4 py-2">
                Services
              </a>
              <a onClick={() => scrollToSection('portfolio')} className="text-gray-700 hover:text-cyan-600 transition-colors cursor-pointer px-4 py-2">
                Portfolio
              </a>
              <a onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-cyan-600 transition-colors cursor-pointer px-4 py-2">
                Pricing
              </a>
              <a onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-cyan-600 transition-colors cursor-pointer px-4 py-2">
                About
              </a>
              <button
                onClick={() => scrollToSection('contact')}
                className="mx-4 px-6 py-2.5 bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-sm font-semibold rounded-full hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Get Started
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
